import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../../services/Advance-search/advance-search.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-manual-edit-phone',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './manual-edit-phone.component.html',
  styleUrl: './manual-edit-phone.component.scss'
})
export class ManualEditPhoneComponent {

  phoneNumber: string = '';

  errorMessage: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManualEditPhoneComponent>,
    private advanceSearch: AdvanceSearchService,
    private toaster: ToastService,
  ) {

    this.phoneNumber =
      data?.devoteeDetails?.contactNumber ||
      data?.contactNumber ||
      '';

  }

  close(): void {

    this.dialogRef.close();

  }

  continue(): void {

    const payLoad = {

      familyCode:
        this.data.devoteeDetails.devoteeFamilyCode,

      devoteeId:
        this.data.devoteeDetails.devoteeId,

      contactNumber:
        this.phoneNumber

    };

    this.advanceSearch.UpdateManualPhone(payLoad).subscribe({

      next: (res: any) => {

        this.toaster.success(
          'Phone number successfully updated'
        );

        this.dialogRef.close(true);

      },

      error: (err: any) => {

        this.errorMessage =
          err?.error?.message || 'Something went wrong';

        this.toaster.error(this.errorMessage);

      }

    });

  }

}